/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Session_Minutes_60Inputs */

const en_us2_onboarding_session_minutes_60 = /** @type {(inputs: Onboarding_Session_Minutes_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 1 h`)
};

const pt_br2_onboarding_session_minutes_60 = /** @type {(inputs: Onboarding_Session_Minutes_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até 1 h`)
};

const es_419_onboarding_session_minutes_60 = /** @type {(inputs: Onboarding_Session_Minutes_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta 1 h`)
};

const pt_pt2_onboarding_session_minutes_60 = /** @type {(inputs: Onboarding_Session_Minutes_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até 1 h`)
};

const fr_fr2_onboarding_session_minutes_60 = /** @type {(inputs: Onboarding_Session_Minutes_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jusqu'à 1 h`)
};

const de_de2_onboarding_session_minutes_60 = /** @type {(inputs: Onboarding_Session_Minutes_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis 1 h`)
};

const it_it2_onboarding_session_minutes_60 = /** @type {(inputs: Onboarding_Session_Minutes_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fino a 1 h`)
};

/**
* | output |
* | --- |
* | "Up to 1 h" |
*
* @param {Onboarding_Session_Minutes_60Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_session_minutes_60 = /** @type {((inputs?: Onboarding_Session_Minutes_60Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Session_Minutes_60Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_session_minutes_60(inputs)
	if (locale === "es-419") return es_419_onboarding_session_minutes_60(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_session_minutes_60(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_session_minutes_60(inputs)
	if (locale === "de-DE") return de_de2_onboarding_session_minutes_60(inputs)
	if (locale === "it-IT") return it_it2_onboarding_session_minutes_60(inputs)
	return en_us2_onboarding_session_minutes_60(inputs)
});
export { onboarding_session_minutes_60 as "onboarding.session_minutes.60" }